
const digest = '3e23ffa14f2691d223cda6bea21bb92eb83c8dbc41c9f24c3798cbf0ad8ad631';
const classes = {"check":"_check_19yeh_1","title":"_title_19yeh_8"};
const css = `._check_19yeh_1 {
  min-width: 18px;
  min-height: 18px;
  max-width: 18px;
  max-height: 18px;
}

._title_19yeh_8 {
  font-size: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  